import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { UserContext } from 'shared/users/contexts/UserContext'
import ROUTES from '../../config/routes'

function useAuthGuard() {
  const navigate = useNavigate()
  const { user, customer } = useContext(UserContext)

  useEffect(() => {
    if (user === undefined && customer === undefined) {
      navigate(`${ROUTES.login}`)
    }
  }, [customer, navigate, user])
}

export default useAuthGuard
